// M8.1 Settings consolidation flag.
//
// Env var: VITE_SETTINGS_V2_ENABLED. #130 slug SETTINGS — this screen
// keeps the per-screen name (strict `=== 'true'`, default OFF). Unset,
// 'false', '1', 'yes', 'TRUE', etc. all stay OFF.
//
// Flag off: /v2/settings is not registered. The catch-all is
// RootRedirect (App.tsx): an authenticated session goes to /home, an
// unauthenticated session goes to /landing. There is no dedicated 404
// page. All existing routes (/admin/*, /settings, /team) work unchanged.
//
// Flag on: /v2/settings renders the consolidated tab surface; existing
// routes STILL work (coexistence, not replacement). Removal of the
// originals is a separate cleanup PR after staging burn-in.

export function isSettingsV2Enabled(): boolean {
  return import.meta.env.VITE_SETTINGS_V2_ENABLED === 'true';
}
